import { css } from '@/styled-system/css';

export const sliderTrackStyles = css.raw({
  position: 'relative',
  width: '100%',
  height: 'Slider.Track.height',
  borderRadius: 'shape.capsule',
  pointerEvents: 'none',
  backgroundColor: 'icon.muted',
  overflow: 'hidden',
});
